import { render, staticRenderFns } from "./InputfieldCheckbox.vue?vue&type=template&id=253e2098&scoped=true&"
import script from "./InputfieldCheckbox.vue?vue&type=script&lang=js&"
export * from "./InputfieldCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253e2098",
  null
  
)

export default component.exports